import { render, staticRenderFns } from "./TrainSet.vue?vue&type=template&id=e924cdba&scoped=true"
import script from "./TrainSet.vue?vue&type=script&lang=js"
export * from "./TrainSet.vue?vue&type=script&lang=js"
import style0 from "./TrainSet.vue?vue&type=style&index=0&id=e924cdba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e924cdba",
  null
  
)

export default component.exports